import React from 'react';
import classnames from 'classnames';
import Text from 'src/components/Text';
import styles from './styles.module.scss';

type Props = {
  disabled?: boolean;
  onClick: () => void;
  className?: string;
  children: React.ReactNode;
};

const LinkButton: React.FC<Props> = ({ disabled, onClick, className, children }) => {
  const linkClassNames = classnames(styles['link'], className);

  const handleClick = (e: any) => {
    e.preventDefault();
    onClick();
  };

  return disabled ? (
    <Text type="span" muted className={linkClassNames}>
      {children}
    </Text>
  ) : (
    <a href="#" onClick={handleClick} className={linkClassNames}>
      {children}
    </a>
  );
};

export default LinkButton;
